import { useEffect } from 'react'
import { createFileRoute, Link, type SearchSchemaInput } from '@tanstack/react-router'
import userStore, { isProfileConfirmed } from "@/stores/user-store"
import { useQuery } from '@tanstack/react-query';
import { check } from '@/queries/login';
import LastTransactions from '@/components/last-transactions'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { CheckIcon, CircleAlert } from 'lucide-react'
// import { FloatingModal } from '@/components/ui/floating-modal'
import { useStore } from '@tanstack/react-store';
import Buy from '@/components/buy';
import { ChargeProvider } from '@/stores/charge-store';
import { disableSplash } from '@/lib/utils';
import { setUser } from '@sentry/react'
import { MultiChargeStoreProvider } from '@/stores/multi-charge-store';
import { getProfile } from '@/queries/profile';

export const Route = createFileRoute('/old/')({
  validateSearch: (search?: Record<string, unknown> & SearchSchemaInput) => {
    if (search && Object.keys(search).length > 0) {
      return {
        t: typeof search.t === "string" ? search.t : undefined,
        r: typeof search.r === "string" ? search.r : undefined,
        next: search.next,
      };
    }
    return undefined
  },
  search: {},
  onEnter(ctx) {
    if (!ctx.search) {
      return
    }

    const { t, r } = ctx.search;
    if (typeof window !== "undefined" && t && r) {
      userStore.setState((prev) => ({
        ...prev,
        token: t,
        refresh_token: r,
        isLoggedIn: true,
      }));
      // Clear query parameters after setting state
      if (window?.history?.replaceState) {
        const url = new URL(window.location.href)
        url.search = ''
        window.history.replaceState({}, document.title, url.toString())
      }
    }
  },
  component: Dashboard,
})


function Dashboard() {
  const { user: currentUser } = useStore(userStore);
  // const [openTv, setOpenTv] = useState(false);

  const checkQuery = useQuery({
    queryFn: () => check(),
    queryKey: ['user', 'check'],
  });

  const profileQuery = useQuery({
    queryFn: () => getProfile(),
    queryKey: ['get', 'profile'],
  })

  useEffect(() => {
    if (!checkQuery.isFetching) {
      disableSplash()

      const user = checkQuery.data?.data?.user || {}
      setUser({
        username: user.mobile,
        id: user.id,
        email: user.name
      })
      userStore.setState((prev) => ({
        ...prev,
        user: checkQuery.data?.data?.user || {},
        points: checkQuery.data?.data.user.points || 0,
        setting: checkQuery.data?.data?.setting?.settings || null,
        two_step: checkQuery.data?.data?.user?.two_step || false,
      }));
    }
  }, [checkQuery]);

  useEffect(() => {
    if (profileQuery.data?.data) {
      userStore.setState((prev) => ({
        ...prev,
        profile: profileQuery.data.data.data
      }))
    }
  }, [profileQuery.data])



  return (
    <>
      <ChargeProvider>
        <MultiChargeStoreProvider>
          {/* 
      <FloatingModal isOpen={openTv} onClose={() => setOpenTv(false)} title="تلویزیون ایساج">
        <iframe src='https://esaj.matato.ir/' className='w-full h-full' />
      </FloatingModal> */}
          <div className='grid grid-cols-1 sm:grid-cols-4 gap-2 md:gap-4 p-2 md:p-0'>
            {!currentUser?.profile_id ? (
              <>
                <Alert className='col-span-1 md:col-span-4'>
                  <CircleAlert className='size-5' />
                  <AlertTitle>تکمیل پروفایل</AlertTitle>
                  <AlertDescription>
                    برای تبدیل شدن اکانت خود به پنل پروفایل خود را تکمیل نمایید
                  </AlertDescription>
                </Alert>
                <div className='flex flex-col gap-2 justify-center items-center h-full w-full relative col-span-4'>
                  برای دسترسی به امکانات پنل باید پروفایل خود را تکمیل کنید
                  <Link to="/profile/complete">
                    <Button>
                      تکمیل پروفایل
                    </Button>
                  </Link>
                </div>
              </>
            ) : currentUser?.type === "ordinary" && !isProfileConfirmed(currentUser) ? (
              <Alert className='col-span-1 md:col-span-4'>
                <CheckIcon className='size-5' />
                <AlertTitle>در انتظار تایید</AlertTitle>
                <AlertDescription>
                  پروفایل شما در دست بررسی می باشد به محض تایید برای شما پیامک ارسال خواهد شد
                </AlertDescription>
              </Alert>
            ) : currentUser?.type === "ordinary" ? (
              <div className='col-span-4 h-full'>
                <LastTransactions />
              </div>
            ) : currentUser?.type !== "panel" ? (
              <></>
            ) : (
              <>
                <div className='col-span-2 sm:col-span-2 h-full'>
                  <Buy />
                </div>
                <div className='col-span-2 sm:col-span-2 h-full'>
                  <LastTransactions />
                </div>
              </>
            )}
          </div>
        </MultiChargeStoreProvider>
      </ChargeProvider>
    </>
  );
}
